module.exports = __webpack_public_path__ + "img/bed.46351b1c.svg";